module.exports = __webpack_public_path__ + "img/Sibiu_e_kl.2cb8d2ac.jpg";